var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: { role: "dialog", id: "ModalTransferir" },
    },
    [
      _c("div", { staticClass: "modal-dialog" }, [
        _c("div", { staticClass: "modal-content" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "modal-body" }, [
            _c("div", { staticClass: "row" }, [
              _vm.cargando_agentes
                ? _c("div", [_vm._m(1)])
                : _c("div", [
                    _vm.agentesDisponibles.length === 0
                      ? _c("div", [_vm._m(2)])
                      : _c("div", [
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", [
                              _vm._v(
                                "Por favor, seleccione un agente para transferir la interacción."
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.agenteSeleccionado,
                                    expression: "agenteSeleccionado",
                                  },
                                ],
                                staticClass: "form-control",
                                staticStyle: { width: "100%" },
                                attrs: { name: "agenteSeleccionado" },
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.agenteSeleccionado = $event.target
                                      .multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                },
                              },
                              [
                                _c("option", { domProps: { value: null } }, [
                                  _vm._v("Seleccione un agente"),
                                ]),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.agentesDisponibles,
                                  function (agente) {
                                    return _c(
                                      "option",
                                      {
                                        key: agente.id,
                                        domProps: { value: agente.id },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(agente.nombre_completo) +
                                            "\n                                    "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                              ],
                              2
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "modal-footer" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-success center-block",
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.transferir.apply(null, arguments)
                                  },
                                },
                              },
                              [_vm._v(" Transferir")]
                            ),
                          ]),
                        ]),
                  ]),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header" }, [
      _c("h4", { staticClass: "modal-title" }, [
        _vm._v("Transferir Interacción"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-12 text-center" }, [
      _c("h4", [
        _c("i", { staticClass: "fal fa-spinner fa-spin" }),
        _vm._v(" Procesando la información..."),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-12 text-center" }, [
      _c("h4", [
        _c("i", { staticClass: "fal fa-warning" }),
        _vm._v(" No existen agentes disponibles"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }